import { Title } from "../Title";
import "./styles.css";
import language from "../../../language";
import RBCLogo from "../../../assets/rbc-logo.png";
import { connect } from "react-redux";

const PARTNERS = [
  {
    image: RBCLogo,
    name: "Rwanda Biomedical Centre",
  },
  {
    image: `${process.env.PUBLIC_URL}/MoH_logo.png`,
    name: "Ministry of Health",
  },
];

const Partners = (props) => {
  const items = [...PARTNERS, ...PARTNERS, ...PARTNERS];

  return (
    <div className="partners-section">
      <Title title={language[props.defaultLanguage].partners} center />
      <div className="partners-track-wrapper">
        <div className="partners-track">
          {items.map((partner, i) => (
            <div key={i} className="partner-logo-item">
              <img src={partner.image} alt={partner.name} />
              <span className="partner-name">{partner.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Partners);
